import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';

import logoImg from '~/assets/icons/logo.webp';
import { BgImage } from '~/components/atoms/bg-element/BgImage';
import { TextBox } from '~/components/atoms/text-box';
import { Icon } from '~/components/ui/icon';
import { Text } from '~/components/ui/text';
import { Title, TITLE_TYPE } from '~/components/ui/title';
import {
  StyledCell,
  StyledContainer,
  StyledHeader,
  StyledRow,
  StyledTable,
  StyledTitleWrapper,
} from '~/pages/HomePage/components/features/styled';
import { getIsMobile } from '~/store/reducers/app/selectors';
import { COLORS } from '~/styles/colors';

const LIST = [
  {
    id: 1,
    name: 'landing:featuresList.staticQrName',
    description: 'landing:featuresList.staticQrDescription',
    qrBrain: true,
    otherServices: true,
  },
  {
    id: 2,
    name: 'landing:featuresList.editingManagementName',
    description: 'landing:featuresList.editingManagementDescription',
    qrBrain: true,
    otherServices: false,
  },
  // {
  //   id: 3,
  //   name: 'landing:featuresList.eventTrackingName',
  //   description: 'landing:featuresList.eventTrackingDescription',
  //   qrBrain: true,
  //   otherServices: false,
  // },
  // {
  //   id: 4,
  //   name: 'landing:featuresList.templatesName',
  //   description: 'landing:featuresList.templatesDescription',
  //   qrBrain: true,
  //   otherServices: false,
  // },
  {
    id: 5,
    name: 'landing:featuresList.personalizationName',
    description: 'landing:featuresList.personalizationDescription',
    qrBrain: true,
    otherServices: false,
  },
  {
    id: 6,
    name: 'landing:featuresList.downloadFormatsName',
    description: 'landing:featuresList.downloadFormatsDescription',
    qrBrain: true,
    otherServices: false,
  },
  {
    id: 7,
    name: 'landing:featuresList.completeAnalyticsName',
    description: 'landing:featuresList.completeAnalyticsDescription',
    qrBrain: true,
    otherServices: false,
  },
  {
    id: 8,
    name: 'landing:featuresList.customDomainName',
    description: 'landing:featuresList.customDomainDescription',
    qrBrain: true,
    otherServices: false,
  },
  // {
  //   id: 9,
  //   name: 'landing:featuresList.unlimitedUsersName',
  //   description: 'landing:featuresList.unlimitedUsersDescription',
  //   qrBrain: true,
  //   otherServices: false,
  // },
  {
    id: 10,
    name: 'landing:featuresList.passwordProtectionName',
    description: 'landing:featuresList.passwordProtectionDescription',
    qrBrain: true,
    otherServices: false,
  },
  // {
  //   id: 11,
  //   name: 'landing:featuresList.bulkCreationName',
  //   description: 'landing:featuresList.bulkCreationDescription',
  //   qrBrain: true,
  //   otherServices: false,
  // },
  {
    id: 12,
    name: 'landing:featuresList.pixelIntegrationName',
    description: 'landing:featuresList.pixelIntegrationDescription',
    qrBrain: true,
    otherServices: false,
  },
];

export default function Features() {
  const { t } = useTranslation();

  const isMobile = useSelector(getIsMobile);

  return (
    <Box sx={{ background: COLORS.lightGray }}>
      <StyledContainer className="customContainer" sx={{ position: 'relative' }}>
        <BgImage.circles $top={78} $left={-114} $zIndex={0} />
        <BgImage.circlesFilled $size={478} $bottom={197} $right={-121} $zIndex={0} />
        <StyledTitleWrapper>
          <Text variant={isMobile ? 'h2' : 'h1.5'}>{t('landing:features.title')}</Text>
          <TextBox text={t('landing:features.makeYouLookSmart')} />
        </StyledTitleWrapper>
        <StyledTable>
          <StyledHeader>
            <StyledCell />
            <StyledCell $isTextCenter>
              <img src={logoImg} alt="logo" height={24} />
            </StyledCell>
            <StyledCell>
              <Title type={TITLE_TYPE.h4} center>
                {t('landing:features.otherServices')}
              </Title>
            </StyledCell>
          </StyledHeader>
          {LIST.map((feature, index) => (
            <StyledRow key={feature.id} $colored={!(index % 2)}>
              <StyledCell>
                <Text variant={isMobile ? 'input15' : 'h3'} sx={{ marginBottom: '8px' }}>
                  {t(feature.name)}
                </Text>
                <Text variant={isMobile ? 'inputVerySmall' : 'input15'} sx={{ color: COLORS.grey400 }}>
                  {t(feature.description)}
                </Text>
              </StyledCell>
              <StyledCell $centered>
                <Icon
                  icon={feature.qrBrain ? 'Check' : 'Close'}
                  withParentColor={false}
                  size={feature.qrBrain ? 20 : 24}
                />
              </StyledCell>
              <StyledCell $centered>
                <Icon
                  icon={feature.otherServices ? 'Check' : 'Close'}
                  withParentColor={false}
                  size={feature.otherServices ? 20 : 24}
                />
              </StyledCell>
            </StyledRow>
          ))}
        </StyledTable>
      </StyledContainer>
    </Box>
  );
}
